import React from 'react';
import CredentialsView from '@fingo/lib/features/profile/views/CredentialsView';
import useCompanyCredentials from '../../../../features/profile/hooks/useCompanyCredentials';

const Credentials = () => (
  <CredentialsView
    useCompanyCredentials={useCompanyCredentials}
    description="Ingresa tus credenciales y acelerarás tus procesos en nuestra plataforma."
    secondaryDescription="Recuerda que todas tus claves están encriptadas, por lo que están seguras con nosotros."
    stackSx={{ ml: 4, pb: 5 }}
    stackProps={{ rowGap: 4 }}
  />
);

export default Credentials;
